import { Component, Input } from '@angular/core';

@Component({
  selector: 'tag-list-dialog',
  templateUrl: './tag-list-dialog.component.html',
  styleUrls: ['./tag-list-dialog.component.scss'],
})
export class TagListDialogComponent {
  @Input() public title = '';
  @Input() public tags: string[] = [];
}
